import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface UploadedPackage {
    id: number;
    reference: string;
}

export interface PackageUploadRequest {
    packages: PackageData[];
}

export interface PackageData {
    reference: string;
    created_at: string;
    carers_required?: number;
    open?: boolean;
    support_required?: string;
    details?: string;
    start_date: string;
    end_date: string;
    weekly_hours?: number;
    commissioner: string;
    clients?: string;
    street_1: string;
    street_2?: string;
    town: string;
    post_code?: string;
    county?: string;
    country?: string;
    lat?: number;
    lng?: number;
    provider?: string;
    care_option: string;
    region: string;
    zone: string;
}


export interface PackageUploadResponse {
    success: boolean;
    message: string;
    data?: {
        uploaded_count: number;
        failed_count: number;
        errors?: string[];
        uploaded_packages?: UploadedPackage[];
    };
}

@Injectable({
    providedIn: 'root'
})
export class DataUploadService {
    private readonly _http = inject(HttpClient);
    private readonly _apiUrl = '/api/data-upload-package';

    /**
     * Upload package data to the server
     * @param packageData Array of package data objects
     * @returns Observable of upload response
     */
    uploadPackages(packageData: PackageData[]): Observable<PackageUploadResponse> {
        const request: PackageUploadRequest = {
            packages: packageData
        };

        return this._http.post<PackageUploadResponse>(this._apiUrl, request);
    }
}
